// Shopify-exact theme matching #008060 primary color
export const theme = {
  colors: {
    // Primary Shopify green
    primary: '#008060',
    primaryHover: '#006e52',
    primaryLight: '#e6f5f0',
    primaryDark: '#005e47',
    
    // Backgrounds
    bg: '#ffffff',
    bgSecondary: '#f6f6f7',
    bgTertiary: '#fafbfb',
    
    // Text
    textPrimary: '#1a1a1a',
    textSecondary: '#6d7175',
    textTertiary: '#8c9196',
    textInverse: '#ffffff',
    
    // Borders
    border: '#e5e5e5',
    borderLight: '#e5e5e5',
    borderDark: '#c9cccf',
    
    // Status colors
    success: '#008060',
    successLight: '#e6f5f0',
    warning: '#f59e0b',
    warningLight: '#fef3c7',
    error: '#d72c0d',
    errorLight: '#fee2e2',
    info: '#006fbb',
    infoLight: '#dbeafe',
    
    // Neutral grays
    gray50: '#fafbfb',
    gray100: '#f6f6f7',
    gray200: '#e5e5e5',
    gray300: '#c9cccf',
    gray400: '#8c9196',
    gray500: '#6d7175',
    gray600: '#4a4c50',
    gray700: '#202223',
    gray800: '#1a1a1a',
    gray900: '#000000',
  },
  
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
    '3xl': '4rem',   // 64px
  },
  
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontFamilyMono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
    
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem',  // 24px
      '3xl': '1.875rem', // 30px
      '4xl': '2.25rem',  // 36px
    },
    
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  
  shadows: {
    sm: '0px 1px 3px rgba(0,0,0,0.08)',
    base: '0px 1px 3px rgba(0,0,0,0.08), 0px 1px 2px rgba(0,0,0,0.06)',
    md: '0px 4px 6px -1px rgba(0,0,0,0.08), 0px 2px 4px -1px rgba(0,0,0,0.06)',
    lg: '0px 10px 15px -3px rgba(0,0,0,0.08), 0px 4px 6px -2px rgba(0,0,0,0.05)',
  },
  
  borderRadius: {
    none: '0',
    sm: '0.375rem',   // 6px
    base: '0.5rem',   // 8px
    md: '0.75rem',    // 12px
    lg: '1rem',       // 16px
    full: '9999px',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    base: '200ms ease-in-out',
    slow: '300ms ease-in-out',
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  // Shopify-specific
  sidebarWidth: '260px',
  cardPadding: '24px',
};

export type Theme = typeof theme;

